module.exports = __webpack_public_path__ + "static/img/NTFusion_logo.2752734.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/NTFusion_logo.png
// module id = rjt6
// module chunks = 7